import { useQuery } from 'react-query'
import { accountOverviewApi } from 'services/account-overview/account-overview'

/**
 * Whether the Account Overview entry point + page should be shown to this user.
 * Cheap server-side check (T2).
 *
 * The gate is correctness-sensitive, so the icon shows ONLY once the server has
 * confirmed visibility — it stays hidden until the query resolves (no optimistic
 * cache seed). That means a qualifying user sees the icon appear ~1-2s after a
 * hard refresh, which is preferable to a stale cache flashing the icon in then
 * out for a user who shouldn't see it at all.
 */
export const useAccountOverviewVisibility = () => {
	const { data, isLoading } = useQuery(
		['account-overview-visibility'],
		() => accountOverviewApi.getVisibility(),
		{
			refetchOnWindowFocus: false
		}
	)

	return {
		isVisible: data?.visible ?? false,
		isLoading
	}
}
